import { SET_PROFILE_DETAILS } from '../actions/profileActions';

export function profileReducer(prevState : any = {}, action : any = {}) {
    switch (action.type) {
        case SET_PROFILE_DETAILS:
            return action.profileDetails;
        default:
            return prevState;
    }
}
